var map = {
	"./qingming1Bg.jpg": "nlkP",
	"./qingming2Bg.jpg": "SohH",
	"./qingming3Bg.jpg": "eSIJ",
	"./qingming4Bg.jpg": "D+uF",
	"./qingming5Bg.jpg": "9/ED",
	"./qingming6Bg.jpg": "zxz4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MkDO";